import { render, staticRenderFns } from "./tableOtherPlatform.vue?vue&type=template&id=3cecedca&scoped=true&"
import script from "./tableOtherPlatform.vue?vue&type=script&lang=js&"
export * from "./tableOtherPlatform.vue?vue&type=script&lang=js&"
import style0 from "./tableOtherPlatform.vue?vue&type=style&index=0&id=3cecedca&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cecedca",
  null
  
)

export default component.exports